<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <h2 class="mx-3 text-left">Manage Time Table Slots</h2>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="3">
        <v-btn color="primary" @click="slotDialog = true" :disabled="isLoading" id="add-time-slot">
          Add Time Slot
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col> 
        <p class="mt-1 mx-3 text-left">Note: Add different timeslots according to lecture timings for different classes</p>
      </v-col>
    </v-row>
    <v-row class="my-2" justify="center">
      <v-col cols="12" md="6" sm="6">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="slotItems"
            single-line
            hide-details
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.start_time="{ item }">
              <p class="text-weight-medium">
                {{ moment(item.start_time, "HH:mm:ss").format("LT") }} -
                {{ moment(item.end_time, "HH:mm:ss").format("LT") }}
              </p>
            </template>

            <template v-slot:item.actions="{ item }">
              <div v-if="false">{{ item }}</div>
              <div class="responsive-icons">
                <v-icon
                  size="26"
                  class="mr-2 blue--text text--darken-4"
                  @click="editTimeslot(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-tooltip bottom :disabled="!item.is_used">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-inline-block">
                      <v-icon
                        size="26"
                        :disabled="item.is_used"
                        class="red--text text--darken-2"
                        @click="triggerDeleteDialog(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </div>
                  </template>
                  <span> This timeslot cannot be deleted as it is already in use </span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="slotDialog" persistent max-width="400px">
        <v-card>
          <v-card-text color="red" class="text-left">
            <v-card-title class="justify-center">
              <!--<v-col>-->
              <h3>{{ is_editing ? "Edit " : "Add " }} Time Slot</h3>
              <!--</v-col>-->
            </v-card-title>
            <v-container>
              <v-form ref="form" v-model="submitForm" @submit.prevent>
                <v-row>
                  <v-col cols="6">
                    <v-dialog
                      ref="startTimeMenu"
                      v-model="startTimeMenu"
                      :return-value.sync="addEditTimeSlot.start_time"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedTime(addEditTimeSlot.start_time)"
                          :rules="[rules.required]"
                          label="Start Time"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="startTimeMenu"
                        v-model="addEditTimeSlot.start_time"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="startTimeMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.startTimeMenu.save(addEditTimeSlot.start_time)
                          "
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="6">
                    <v-dialog
                      ref="endTimeMenu"
                      v-model="endTimeMenu"
                      :return-value.sync="addEditTimeSlot.end_time"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedTime(addEditTimeSlot.end_time)"
                          :rules="[rules.required]"
                          label="End Time"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="endTimeMenu"
                        v-model="addEditTimeSlot.end_time"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="endTimeMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.endTimeMenu.save(addEditTimeSlot.end_time)
                          "
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="6" align-self="center">
                    <div class="text-center">
                      <v-btn
                        color="#B71C1C"
                        dark
                        @click="closeTimeslotDialog()"
                      >
                        Cancel
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="6" align-self="center">
                    <div class="text-center">
                      <v-btn
                        color="primary"
                        @click="saveTimeslot()"
                        :disabled="!submitForm || isLoading"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- delete dialog -->
    <DeleteConfirmationDialog
      title="Are you sure you want to delete this topic?"
      :visible="showDeleteConfirmation"
      description="This action cannot be undone"
      @deleteObject="deleteTimeslot"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
import moment from "moment";
import TourHelper from "@utils/tour_helper";


export default {
  name: "TimeTableSlots",
  components: {
    DeleteConfirmationDialog,
  },
  data() {
    return {
      moment: moment,
      rules: {
        required: (v) => !!v || "This field is required",
      },
      submitForm: false,
      slotDialog: false,
      addEditTimeSlot: {
        start_time: null,
        end_time: null,
        // id: null
        institution: null,
      },
      snackbar: {
        visible: false,
        text: "",
      },
      startTimeMenu: false,
      endTimeMenu: false,
      is_editing: false,
      headers: [
        {
          text: "Time",
          value: "start_time",
        },
        {
          text: "Actions",
          value: "actions",
          sortable:false,
        },
      ],
      slotItems: [],

      showDeleteConfirmation: false,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution",
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Time Table Slots", description: "Add or edit new time slots for timetable.", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Add new time slot by filling neccessary information.", position:'top' ,el: '#add-time-slot'});
        TourHelper.startTour(this, "time__table__slots", steps);
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    formattedTime(time) {
      if (!time) return;

      var format = moment(time, "HH:mm").format("LT");
      return format;
    },

    async getSlots() {
      var url = endpoints.getTimeSlots;
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        this.slotItems = response;
      }
    },

    editTimeslot(item) {
      this.is_editing = true;
      this.slotDialog = true;
      this.addEditTimeSlot = {
        start_time: item.start_time,
        end_time: item.end_time,
        id: item.id,
        institution: this.currentInstitution.id,
      };
    },

    validate() {
      if (this.addEditTimeSlot.start_time && this.addEditTimeSlot.end_time) {
        let startTime = moment(this.addEditTimeSlot.start_time, "HH:mm");
        let endTime = moment(this.addEditTimeSlot.end_time, "HH:mm");
        if (endTime.isBefore(startTime)) {
          // check if out_time is not before in_time
          this.snackbar.text = "Invalid time range";
          this.snackbar.visible = true;
          return false;
        }
        return true;
      }
    },

    async saveTimeslot() {
      if (this.validate()) {
        var url = endpoints.getTimeSlots;
        // this.slotDialog = true
        var response;
        if (!this.is_editing) {
          response = await api.handleApi({
            apiEssentials: this.essentials,
            url: url,
            responseVar: response,
            method: api.Methods.POST,
            body: this.addEditTimeSlot,
          });
        } else {
          response = await api.handleApi({
            apiEssentials: this.essentials,
            url: (url += `${this.addEditTimeSlot.id}/`),
            responseVar: response,
            method: api.Methods.PUT,
            body: this.addEditTimeSlot,
          });
        }

        if (response) {
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
          this.slotDialog = false;
          this.snackbar.text = "Timeslot Saved";
          this.snackbar.visible = true;
          this.snackbar.color = "success";

          this.getSlots();
        }
      }
    },

    triggerDeleteDialog(item) {
      this.addEditTimeSlot.id = item.id;
      this.showDeleteConfirmation = true;
    },

    async deleteTimeslot(confirm) {
      var url = endpoints.getTimeSlots;
      // eslint-disable-next-line no-unused-vars
      var response;

      if (confirm) {
        url += `${this.addEditTimeSlot.id}/`;
        response = await api.handleApi({
          apiEssentials: this.essentials,
          url: url,
          responseVar: response,
          method: api.Methods.DELETE,
        });

        if (response) {
          this.showDeleteConfirmation = false;
          this.snackbar.text = "Timeslot deleted";
          this.snackbar.visible = true;
          this.getSlots();
        }
      } else {
        this.showDeleteConfirmation = false;
      }

      this.getSlots();
    },

    closeTimeslotDialog() {
      if (this.$refs.form) this.$refs.form.reset();

      this.slotDialog = false;
      this.addEditTimeSlot = {
        start_time: null,
        end_time: null,
        institution: this.currentInstitution.id,
      };
    },
  },

  created() {
    this.getSlots();
    this.addEditTimeSlot.institution = this.currentInstitution.id;
    this.handleTour();
  },
};
</script>
<style scoped>
.responsive-icons {
  /* To keep the icons from breaking */
  min-width: 60px;
}
</style>
